import { useEffect, useMemo, useRef } from "react";
import { useEvidenceModalSocketStore } from "../store/admin/evidenceModalSocketStore";
import type { EvidenceFilter } from "../evidenceSocket";

export const useModalEvidenceSubscription = (filter: EvidenceFilter) => {
  const connect = useEvidenceModalSocketStore((state) => state.connect);
  const disconnect = useEvidenceModalSocketStore((state) => state.disconnect);
  const updateSubscription = useEvidenceModalSocketStore(
    (state) => state.updateSubscription
  );
  const isConnected = useEvidenceModalSocketStore((state) => state.isConnected);
  const error = useEvidenceModalSocketStore((state) => state.error);
  const joinedRooms = useEvidenceModalSocketStore((state) => state.joinedRooms);

  const filterKey = useMemo(() => JSON.stringify(filter), [filter]);
  const filterRef = useRef(filter);
  filterRef.current = filter;

  const hasMounted = useRef(false);

  useEffect(() => {
    connect(filterRef.current);

    return () => {
      disconnect();
    };
  }, [connect, disconnect]);

  useEffect(() => {
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }
    updateSubscription(filterRef.current);
  }, [filterKey, updateSubscription]);

  return {
    isConnected,
    error,
    joinedRooms,
  };
};

export default useModalEvidenceSubscription;
